<template>
  <div class="w-full height-100">
    <el-dialog title="" :visible.sync="addErrorCodesPopup" width="30%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">Add</h3></template
      >
      <div>
        <div class="">
          <div class="relative">
            <small class="fsize12 bg-white text-dark font-semibold"
              >Error Code</small
            >
            <el-input
              v-model="errorcode"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark font-semibold"
              >Error Message</small
            >
            <el-input
              v-model="errormsg"
              type="textarea"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark font-semibold"
              >Response Type</small
            >
            <el-input
              v-model="Custom"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
              disabled
            />
          </div>
        </div>

        <div class="flex justify-center gap-4">
          <vs-button
            type="primary"
            class="bg-primary w-full rounded-lg mt-8 px-8 py-3"
            @click="handleaddcode"
            >Add</vs-button
          >
          <vs-button
            type="secondary"
            class="bg-secondary w-full rounded-lg mt-8 px-8 py-3"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="editErrorCodesPopup" width="30%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">Edit</h3></template
      >
      <div>
        <div class="">
          <div class="relative">
            <small class="fsize12 bg-white text-dark">Error Code</small>
            <el-input
              v-model="errorcode"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark">Error Message</small>
            <el-input
              v-model="errormsg"
              type="textarea"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
            />
          </div>
          <div class="relative mt-4">
            <small class="fsize12 bg-white text-dark">Response Type</small>
            <el-input
              v-model="Custom"
              placeholder="Enter..."
              maxlength="50"
              class="rounded-xl mt-2"
              disabled
            />
          </div>
        </div>
        <div class="flex justify-center gap-4">
          <vs-button
            type="primary"
            class="bg-primary w-full mt-8 px-8 py-3"
            @click="handleupdatecode"
            >Save</vs-button
          >
          <vs-button type="secondary" class="w-full bg-secondary mt-8 px-8 py-3"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Error Management
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top menucontrol-scroll bg-white p-6">
      <div class="flex justify-between gap-4 items-center w-full">
        <div class="relative w-1/2">
          <el-input
            placeholder="Search"
            v-model="search"
            maxlength="50"
            class="rounded-none w-full py-3 px-3"
          />

          <div class="absolute top-0 right-0 m-2 p-3">
            <feather-icon icon="SearchIcon" class="" />
          </div>
        </div>
        <div class="flex gap-2 w-1/2 items-center">
          <div class="w-1/2">
            <el-select v-model="value" placeholder="Select">
              <el-option
                v-for="item in restype"
                :key="item"
                :label="item"
                :value="item"
              >
                <div @click="handlefilter(item)">{{ item }}</div>
              </el-option>
            </el-select>
          </div>
          <div class="w-1/2 flex justify-end gap-4 items-center">
            <vs-button
              type="primary"
              class="bg-primary px-10 py-3 rounded-lg"
              @click="PopupWindow"
              >Add
            </vs-button>
            <el-tooltip class="item" effect="light" placement="top-start">
              <el-button class="py-2 px-2 bg-fas" @click="handleremocve">
                <feather-icon icon="InfoIcon" class=""
              /></el-button>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="">
        <!-- :data="errorcodes" -->
        <el-table
          :data="Errors[0].paginatedresult"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column prop="title" label="Error ID" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.errorid }}</P>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorCode"
            label="Error Code"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.errorcode }}</P>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorMsg"
            label="Error Message"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.errormessage }}</P>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorCode"
            label="Response Type"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.responcetype }}</P>
            </template>
          </el-table-column>

          <el-table-column prop="" label="Actions" min-width="100px">
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center">
                <feather-icon
                  @click="handleediterror(row)"
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  :class="{
                    cursornotallow: row.responcetype == 'System',
                    'cursor-pointer': row.responcetype == 'Custom',
                  }"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-4 h-4"
                  :class="{
                    cursornotallow: row.responcetype == 'System',
                    'cursor-pointer': row.responcetype == 'Custom',
                  }"
                  @click="handleremove(row)"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="w-full flex justify-end mt-6"
          v-if="Errors[0].totalcount.length > 0"
        >
          <el-pagination
            pills
            :total="Number(Errors[0].totalcount[0].count)"
            layout="prev,pager,next"
            background
            :current-page="currentPage"
            @current-change="handlePageChange"
            size="sm"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showerror: false,
      offset: null,
      addErrorCodesPopup: false,
      search: "",
      title: "",
      errorMsg: "",
      des: "",
      errorCode: "",
      errorcode: "",
      value: "",
      errormsg: "",
      editstatus: false,
      currentPage: 1,
      editdata: {},
      Custom: "Custom",
      isNewData: true,
      id: "",
      restype: ["Custom", "System"],
      drawer: false,
      editErrorCodesPopup: false,
      direction: "rtl",

      // subcategoryoptions: [
      //   {
      //     value: "HTML",
      //     label: "HTML",
      //   },
      //   {
      //     value: "CSS",
      //     label: "CSS",
      //   },
      //   {
      //     value: "JavaScript",
      //     label: "JavaScript",
      //   },
      // ],
      tableData: [
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
        {
          date: "20 December 2019",
          name: "Tom",
          state: "PR-1",
          city: "Active",
          address: "No. 189, Grove St, Los Angeles",
          zip: "CA 90036",
        },
      ],
    };
  },
  computed: {
    ...mapState("errorcodes", ["errorcodes"]),
    ...mapState("Errormanagment", ["Errors"]),
  },
  methods: {
    handlshowpreview(row) {
      if (row.responcetype == "System") {
        this.showerror = true;
      }
    },
    async handleremocve() {
      this.val = "";
      this.value = "";
      await this.Geterror();
    },
    async handlefilter(val) {
      this.val = val;
      this.Geterror();
    },
    async handleremove(row) {
      if (row.responcetype == "System") return;
      var payload = {
        id: row._id,
        isDeleted: true,
      };
      try {
        this.$swal({
          title: "Are you sure?",
          type: "Warning",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it",
          cancelButtonText: "No, keep it",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.$swal("Deleted", "Successfully deleted", "success");
            let data = this.$store.dispatch("Errormanagment/Update", payload);
            this.addErrorCodesPopup = false;
            this.Geterror();
          } else {
            this.$swal("Cancelled, File is still intact");
            this.Geterror();
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    getMessage(message, type) {
      this.$swal({
        text: message,
        icon: type,
        timer: 1500,
        confirmButtonColor: "#CD3197",
        confirmButtonText: "OK",
      });
    },
    async handleupdatecode() {
      const payload = {
        id: this.id,
        errorcode: this.errorcode,
        errormessage: this.errormsg,
        responcetype: this.Custom,
      };
      try {
        let data = await this.$store.dispatch("Errormanagment/Update", payload);
        if (data.code == 200) {
          this.editErrorCodesPopup = false;
          await this.Geterror();
          this.reset();
          this.getMessage("Recorded Updated", "success");
        }
        if (data.code == 409) {
          this.getMessage("Error Code Allready Exists", "warning");
        }
      } catch (err) {
        this.editErrorCodesPopup = false;
        this.reset();
        this.getMessage("somtthing went wrong", "warning");
        console.log(err);
      }
    },
    async handleediterror(row) {
      if (row.responcetype == "System") return;
      this.editErrorCodesPopup = true;
      this.editstatus = true;
      this.id = row._id;
      this.errormsg = row.errormsg;
      this.errorcode = row.errorcode;
    },
    async handlePageChange(value) {
      this.currentPage = value;

      this.offset =
        this.currentPage > 1 ? (this.currentPage - 1) * 10 : this.currentPage;
      this.Geterror();
    },
    async reset() {
      this.errormsg = "";

      this.errorcode = "";
    },
    async Geterror() {
      try {
        const payload = {};

        if (this.offset != null) {
          Object.assign(payload, { offset: this.offset });
        }
        if (this.search != "") Object.assign(payload, { search: this.search });
        if (this.val != "") Object.assign(payload, { responcetype: this.val });
        await this.$store.dispatch("Errormanagment/Get", payload);
      } catch (err) {
        console.log(err);
      }
    },
    async handleaddcode() {
      const payload = {
        errorcode: this.errorcode,
        errormessage: this.errormsg,
        responcetype: this.Custom,
      };
      try {
        const data = await this.$store.dispatch(
          "Errormanagment/Create",
          payload
        );
        if (data.data.code == 409) {
          this.getMessage("ErrorCode Allready Exists", "warning");
        } else {
          this.addErrorCodesPopup = false;
          this.reset();
          await this.Geterror();
          this.$swal({
            text: "Record added",
            icon: "success",
            timer: 1500,
            confirmButtonColor: "#CD3197",
            confirmButtonText: "OK",
          });
        }
      } catch (err) {
        this.addErrorCodesPopup = false;
        this.$swal({
          text: "Something wrong",
          icon: "worning",
          timer: 1500,
          confirmButtonColor: "#CD3197",
          confirmButtonText: "OK",
        });
        console.log(err);
      }
    },
    async handleClick() {
      let data = await this.$store.dispatch("errorcodes/addErrorCodes", {
        title: this.title,
        errorMsg: this.errorMsg,
        description: this.des,
        errorCode: this.errorCode,
      });

      if (data) {
        this.getErrorCodesFunc();
        this.addErrorCodesPopup = false;
      }
      console.log(data);
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    PopupWindow() {
      this.addErrorCodesPopup = true;
      this.isNewData = true;
    },

    async getErrorCodesFunc() {
      let data = await this.$store.dispatch("errorcodes/getErrorCodes");
      console.log(data);
    },
    async editErrorCodes(editdata) {
      this.isNewData = false;
      console.log(editdata);
      this.editdata = editdata;
      this.addErrorCodesPopup = true;
      (this.title = editdata.title),
        (this.errorMsg = editdata.errorMsg),
        (this.errorCode = editdata.errorCode),
        (this.des = editdata.description);
    },
    async editErrorCodesFunc() {
      let payload = {
        _id: this.editdata._id,
      };

      if (this.title != this.editdata.title) {
        Object.assign(payload, { title: this.title });
      }

      if (this.errorMsg != this.editdata.errorMsg) {
        Object.assign(payload, { errorMsg: this.errorMsg });
      }

      if (this.des != this.editdata.description) {
        Object.assign(payload, { description: this.des });
      }

      if (this.errorCode != this.editdata.errorCode) {
        Object.assign(payload, { errorCode: this.errorCode });
      }

      let data = await this.$store.dispatch(
        "errorcodes/editErrorCodes",
        payload
      );
      this.addErrorCodesPopup = false;
      this.getErrorCodesFunc();
      console.log(data);
    },
    async removeErrorCodesFunc(value) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          let data = this.$store.dispatch("errorcodes/editErrorCodes", {
            _id: value._id,
            isDeleted: true,
          });
          this.addErrorCodesPopup = false;
          this.getErrorCodesFunc();
        } else {
          this.$swal("Cancelled, File is still intact");
          this.getErrorCodesFunc();
        }
      });
    },
  },
  watch: {
    search(val) {
      this.Geterror();
    },
    addErrorCodesPopup(newValue) {
      if (!newValue) {
        (this.title = ""),
          (this.errorCode = ""),
          (this.errorMsg = ""),
          (this.des = "");
      }
    },
  },
  mounted() {
    // this.getErrorCodesFunc();
    this.Geterror();
    console.log(this.Errors, "ErrorsErrorsErrors");
  },
};
</script>
